import React, {} from 'react';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';
import Placeholder from '../placeholder';

import { determineBaseProperties } from '../utilities';

function Paragraph(props) {

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: []
  }, nodeControls);

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: '',
      contentEditable: baseElementProperties.contentEditable
    };

    return <div {...attributes}>
      {<Placeholder element={props.element} placeholder={props.placeholder} />}
      {props.children}
    </div>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default Paragraph;